import React, { useState } from 'react';
import { Tabs, Tab, Box } from '@material-ui/core';
import { IGame } from '@pvplevelup/core/dist/interfaces/Game/IGame';
import { KillAdvantageGraph, ScoreAdvantageGraph } from './KillAdvantageGraph';
import { KothControlPointPies } from './KothControlPointPies';
import { CharacterDamageGraph, CharacterKillsGraph, CharacterDeathsGraph } from './CharacterDamageGraph';
import { AbilityBreakdown } from './AbilityBreakdown';

enum GameScoreTab {
  Score = "Score",
  Graphs = "Graphs",
  Abilities = "Abilities",
}

interface Props {
  game: IGame;
}

/** Score (default) shows the children (the scoreboard); Graphs shows charts built from the game's deaths; Abilities each player's damage by ability. */
export const GameScoreTabs: React.FC<Props> = ({game, children}) => {
  const [tab, setTab] = useState<GameScoreTab>(GameScoreTab.Score);
  return (
    <React.Fragment>
      <Tabs value={tab} onChange={(event, value) => setTab(value)} indicatorColor="primary" textColor="primary" className="game-tabs">
        <Tab value={GameScoreTab.Score} label="Scoreboard" className="game-tab" />
        <Tab value={GameScoreTab.Graphs} label="Graphs" className="game-tab" />
        <Tab value={GameScoreTab.Abilities} label="Abilities" className="game-tab" />
      </Tabs>
      <Box mt={1}>
        {tab == GameScoreTab.Score ? children : tab == GameScoreTab.Abilities ? <AbilityBreakdown game={game} /> :
          // the game view's map image sits behind this panel; a near-solid background keeps the charts readable
          <Box style={{background: 'rgba(20, 20, 20, 0.92)', border: '1px solid rgba(255, 255, 255, 0.12)', borderRadius: 8, padding: 12}}>
            <KillAdvantageGraph game={game} />
            <Box mt={3}>
              <ScoreAdvantageGraph game={game} />
            </Box>
            <KothControlPointPies game={game} />
            <Box mt={3}>
              <CharacterDamageGraph game={game} />
            </Box>
            <Box mt={3}>
              <CharacterKillsGraph game={game} />
            </Box>
            <Box mt={3}>
              <CharacterDeathsGraph game={game} />
            </Box>
          </Box>
        }
      </Box>
    </React.Fragment>
  );
}
